import { getApiUrl } from '../api/config';

const getBaseUrl = () => `${getApiUrl()}/insight-lab`;

const getToken = () => localStorage.getItem('access_token');

const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getToken()}`
});

export async function getSessions() {
  const res = await fetch(`${getBaseUrl()}/sessions`, { headers: headers() });
  if (!res.ok) throw new Error('Failed to fetch sessions');
  const data = await res.json();
  return data.sessions;
}

export async function createSession() {
  const res = await fetch(`${getBaseUrl()}/sessions`, {
    method: 'POST',
    headers: headers()
  });
  if (!res.ok) throw new Error('Failed to create session');
  return res.json();
}

export async function getSession(id) {
  const res = await fetch(`${getBaseUrl()}/sessions/${id}`, { headers: headers() });
  if (!res.ok) throw new Error('Failed to load session');
  const data = await res.json();
  return data.session;
}

export async function sendMessage(sessionId, message) {
  const res = await fetch(`${getBaseUrl()}/sessions/${sessionId}/message`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ message })
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to send message');
  }
  return res.json();
}

export async function autosaveSession(sessionId, messages) {
  const res = await fetch(`${getBaseUrl()}/sessions/${sessionId}/autosave`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ messages })
  });
  if (!res.ok) throw new Error('Failed to autosave');
  return res.json();
}

export async function updateSession(id, data) {
  const res = await fetch(`${getBaseUrl()}/sessions/${id}`, {
    method: 'PATCH',
    headers: headers(),
    body: JSON.stringify(data)
  });
  if (!res.ok) throw new Error('Failed to update session');
  return res.json();
}

export async function deleteSession(id) {
  const res = await fetch(`${getBaseUrl()}/sessions/${id}`, {
    method: 'DELETE',
    headers: headers()
  });
  if (!res.ok) throw new Error('Failed to delete session');
  return res.json();
}
